const parseRGB = (rgbStr) => {
    // handle rgb(255, 255, 255)
    const match = rgbStr.match(/rgb[a]?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*[,\)]/i);
    if (match) {
        return {
            r: parseInt(match[1], 10),
            g: parseInt(match[2], 10),
            b: parseInt(match[3], 10)
        };
    }
    throw new Error(`'error: ', ${rgbStr}`);
};
const getRelativeLuminance = (r, g, b) => {
    const rs = r / 255;
    const gs = g / 255;
    const bs = b / 255;
    const rl = rs <= 0.03928 ? rs / 12.92 : Math.pow((rs + 0.055) / 1.055, 2.4);
    const gl = gs <= 0.03928 ? gs / 12.92 : Math.pow((gs + 0.055) / 1.055, 2.4);
    const bl = bs <= 0.03928 ? bs / 12.92 : Math.pow((bs + 0.055) / 1.055, 2.4);
    // // white (#ffffff)
    // console.log(getRelativeLuminance(255, 255, 255)); // ≈ 1.0
    // // black (#000000)
    // console.log(getRelativeLuminance(0, 0, 0));       // = 0.0
    // // red (#ff0000)
    // console.log(getRelativeLuminance(255, 0, 0));     // ≈ 0.2126
    return 0.2126 * rl + 0.7152 * gl + 0.0722 * bl;
};
export const setContrastTextColor = (elem, isEnable = false) => {
    if (!isEnable) {
        return;
    }
    const bgImg = window.getComputedStyle(elem).backgroundImage;
    if (bgImg !== 'none') {
        return;
    }
    const bgColor = window.getComputedStyle(elem).backgroundColor;
    const { r, g, b } = parseRGB(bgColor);
    const luminance = getRelativeLuminance(r, g, b);
    // 0.179 -> 0.3 -> 0.4
    const textColor = luminance > 0.4 ? 'black' : 'white';
    elem.style.color = textColor;
    // for testing
    // elem.textContent += ` (L=${luminance.toFixed(3)})`;
};
